module.exports = __webpack_public_path__ + "img/login_4.8771c3eb.png";